import { createApi } from "@reduxjs/toolkit/query/react";
import { apiRequestBaseQuery } from "../../services/rtkBaseQuery";
import { getUserDetails } from "../../services/apiRequest";
import { requestType } from "../../services/requests";

// =============================================================================
// ROYAL MOMENTUM - Profile API
// =============================================================================

export const royalMomentumProfileApi = createApi({
    reducerPath: "royalMomentumProfileApi",
    baseQuery: apiRequestBaseQuery,
    tagTypes: ["Profile"],
    endpoints: (builder) => ({
        // Get Agency Profile
        getAgencyProfile: builder.query({
            query: (travelAgencyUid) => {
                const userDetails = getUserDetails();
                return {
                    // V2: agency_id (= selectedBrand.uid = agency_id_no_r) replaces travel_agency_uid
                    requestType: requestType.getAgencyProfileDetailV2,
                    data: {
                        user_uid: userDetails?.user_details?.uid,
                        agency_id: travelAgencyUid,
                    },
                };
            },
            providesTags: ["Profile"],
        }),
        // Get Agency Overview
        getAgencyOverview: builder.query({
            query: (travelAgencyUid) => {
                const userDetails = getUserDetails();
                return {
                    requestType: requestType.getAgencyOverview,
                    data: {
                        user_uid: userDetails?.user_details?.uid,
                        travel_agency_uid: travelAgencyUid,
                    },
                };
            },
            providesTags: ["Profile"],
        }),
        // Set Agency Profile
        setAgencyProfile: builder.mutation({
            query: ({ travelAgencyUid, agencyType, totalStores, hasRegionalStructure, totalSalesRegions }) => {
                const userDetails = getUserDetails();
                return {
                    // V2: agency_id (= selectedBrand.uid = agency_id_no_r) replaces travel_agency_uid
                    requestType: requestType.setAgencyProfileV2,
                    data: {
                        user_uid: userDetails?.user_details?.uid,
                        agency_id: travelAgencyUid,
                        agency_type: agencyType,
                        total_stores: totalStores,
                        has_regional_structure: hasRegionalStructure,
                        total_sales_regions: totalSalesRegions,
                    },
                };
            },
            invalidatesTags: ["Profile"],
        }),
    }),
});

// Export hooks for usage in components
export const {
    useGetAgencyProfileQuery,
    useGetAgencyOverviewQuery,
    useSetAgencyProfileMutation,
} = royalMomentumProfileApi;
